export default function mergeUniqueArray(array1, array2) {
    // returns unique array from two merged arrays and removes duplicate items
    const ids = new Set(array1.map((d) => d.user_id));
    const merged = [...array1, ...array2.filter((d) => !ids.has(d.id))];
    return merged;
}
